import React, { useState } from 'react'
import { useStaticQuery, graphql, Link } from "gatsby"
import {
  Bars3Icon
} from '@heroicons/react/24/outline'
import {
	PhoneIcon
  } from '@heroicons/react/24/solid'
import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';
import SearchButton from './SearchButton';
// import LanguagesMenu from './LanguagesMenu';
import { LogoLight, LogoMobile } from '../../images/logo';
import SearchModal from '../SearchModal/SearchModal';
import { OutboundLink } from "gatsby-plugin-google-gtag"

export default function Header({changeLocale, locale, hideMenu, darkMenu, CountryPromptBanner}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const data = useStaticQuery(graphql`
        query MenuQuery {
            allStrapiTilMenu(sort: {Order: ASC}) {
				edges {
					node {
						id
						Section
						InternalLink
						CallToActions {
							id
							LinkLabel
							InternalLink
							ExternalLink
							Description
							Text
							Image {
								formats {
									small {
										url
									}
									medium {
										url
									}
									large {
										url
									}
								}
							}
						}
						Links {
							id
							Name
							InternalLink
						}
					}
				}
			}
            }
         `)

  if (hideMenu) { 
	return null;
  }

  return (
    <header className={`absolute £${CountryPromptBanner ? 'top-12' : 'top-0'} z-40  backdrop-blur-md ${darkMenu ? 'bg-global-700/40' : 'bg-global-700/25'} transition-all duration-300 m-2 lg:m-5 rounded-sm mobile-menu-banner lg:desktop-menu-banner`}>
      <nav className="h-[70px] lg:h-24 flex max-w-full items-center justify-between p-4 lg:p-6 lg:px-10 py-5" aria-label="Global">
        <div className="flex xl:flex-1 opacity-100">
          <Link to="/" className="-m-1.5 p-1.5">
            <span className="sr-only">The Information Lab Logo</span>
            <div className='hidden xl:block'>{LogoLight}</div>
			<div className='xl:hidden'>{LogoMobile}</div>
          </Link>
        </div>
		
        <div className="flex xl:hidden">
			<OutboundLink href="tel:+448453888289" className='mt-[7px] mr-8'>
			<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M3.65697 6.04173C5.1976 8.49202 6.22515 9.47217 8.79259 10.9425L10.8469 8.98219C11.8959 9.23809 13.2208 9.58934 14.2833 9.58514C14.6377 9.58233 14.9907 9.92027 15 10.2435L14.9764 13.3017C14.975 13.6396 14.6191 13.9796 14.2583 14C5.40677 14.0147 0.28981 9.13152 0.00169337 0.668582C-0.0276049 0.341871 0.328262 0.0018425 0.682692 0.000424591H4.19278C4.58008 -0.0135974 4.93308 0.322936 5.0174 0.528353C4.92736 1.67535 5.43686 3.07413 5.71126 4.08156L3.65697 6.04173Z" fill="white"/>
			</svg>
			</OutboundLink>
			<SearchButton setOpen={setSearchOpen} />
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
		<div className='hidden xl:block'>
			<div className='flex text-xs justify-between mb-5'>
				<div className='flex py-1 uppercase text-white font-normal text-[13px]'><PhoneIcon className='w-4'/><span> +44 (0)8453 888 289</span></div>
				<div className='flex'>
					{/* <LanguagesMenu locale={locale} changeLocale={(l) => changeLocale(l)}/> */}
					<SearchButton setOpen={setSearchOpen} />
					<button
						type="button"
						onClick={() => {
							window?.open("https://support.theinformationlab.co.uk/")
						}}
						className="inline-flex cursor-pointer items-center justify-center w-32 h-7 text-white bg-moon-700 rounded-full shadow-xs"
					>
						<span className="sr-only">Got to Support Desk</span>
						<div className='uppercase text-white font-semibold text-[12px]' style={{letterSpacing: 0.84}}>Support Desk</div>
					</button>
					
				</div>
			</div>
			<DesktopMenu mainMenu={data?.allStrapiTilMenu?.edges} />
		</div>
        
      </nav>
      <MobileMenu mobileMenuOpen={mobileMenuOpen} mainMenu={data?.allStrapiTilMenu?.edges} setMobileMenuOpen={setMobileMenuOpen}/>
	  <SearchModal open={searchOpen} close={() => setSearchOpen(false)} />
    </header>
  )
}